<div class="form-wrap"
     cdkDrag
>
    <form [formGroup]="activateForm"
          class="form"
    >
        <div class="form-title"
             cdkDragHandle
        >
            <img [src]="'../../../../assets/images/logos/pro-business.svg'">
        </div>
        <mat-form-field style="width: 100%;"
                        class="form-field-cs"
        >
            <mat-label>{{ replaceAsteriks('ACTIVATE.CODE' | translate) }}</mat-label>
            <input matInput
                   formControlName="invite_code"
                   autocomplete="disabled"
                   data-cy="code-input"
            >
            <mat-error *ngIf="invite_code?.errors?.['required']"
                       data-cy="code-error-required"
            >
                {{ 'VALIDATION.REQUIRED' | translate }}
            </mat-error>
        </mat-form-field>
        <mat-form-field style="width: 100%;"
                        class="form-field-cs"
        >
            <mat-label>{{ replaceAsteriks('ACTIVATE.ENTER_EMAIL' | translate) }}</mat-label>
            <input matInput
                   formControlName="email"
                   autocomplete="disabled"
                   data-cy="email-input"
            >
            <mat-error *ngIf="email?.errors?.['required']"
                       data-cy="email-error-required"
            >
                {{ 'VALIDATION.REQUIRED' | translate }}
            </mat-error>
            <mat-error *ngIf="email?.errors?.['email']"
                       data-cy="email-error-validation"
            >
                {{ 'VALIDATION.EMAIL' | translate }}
            </mat-error>
        </mat-form-field>
        <mat-form-field style="width: 100%;"
                        class="form-field-cs"
        >
            <mat-label>{{ replaceAsteriks('ACTIVATE.PASS' | translate) }}</mat-label>
            <input matInput
                   formControlName="passwd"
                   autocomplete="disabled"
                   data-cy="password-input"
            >
            <mat-error *ngIf="password?.errors?.['required']"
                       data-cy="password-error-required"
            >
                {{ 'VALIDATION.REQUIRED' | translate }}
            </mat-error>
            <mat-error *ngIf="password?.errors?.['minlength']"
                       data-cy="password-error-minLength"
            >
                {{ 'VALIDATION.PASS_LENGTH' | translate }}
            </mat-error>
        </mat-form-field>
        <mat-form-field class="form-field-cs"
                        autocomplete="disabled"
        >
            <mat-label>{{ replaceAsteriks('ACTIVATE.CONFIRM_PASS' | translate) }}</mat-label>
            <input matInput
                   formControlName="passwd2"
                   autocomplete="new-password"
                   data-cy="password-check-input"
            >
            <mat-error *ngIf="password2?.errors?.['required']"
                       data-cy="password-check-error-required"
            >
                {{ 'VALIDATION.REQUIRED' | translate }}
            </mat-error>
            <mat-error *ngIf="password2?.errors?.['minlength']"
                       data-cy="password-check-error-minLength"
            >
                {{ 'VALIDATION.PASS_LENGTH' | translate }}
            </mat-error>
            <mat-error *ngIf="password2?.errors?.['passowrdDifference']"
                       data-cy="password-check-error-difference"
            >
                {{ 'VALIDATION.PASS_MATCH' | translate }}
            </mat-error>
        </mat-form-field>
        <mat-form-field class="form-field-cs"
                        autocomplete="disabled"
        >
            <mat-label>{{ replaceAsteriks('ACTIVATE.FIRSTNAME' | translate) }}</mat-label>
            <input matInput
                   formControlName="firstname"
                   data-cy="firstname-input"
            >
            <mat-error *ngIf="firstname?.errors?.['required']"
                       data-cy="firstname-error-required"
            >
                {{ 'VALIDATION.REQUIRED' | translate }}
            </mat-error>
        </mat-form-field>
        <mat-form-field class="form-field-cs"
                        autocomplete="disabled"
        >
            <mat-label>{{ replaceAsteriks('ACTIVATE.LASTNAME' | translate) }}</mat-label>
            <input matInput
                   formControlName="lastname"
                   data-cy="lastname-input"
            >
            <mat-error *ngIf="lastname?.errors?.['required']"
                       data-cy="lastname-error-required"
            >
                {{ 'VALIDATION.REQUIRED' | translate }}
            </mat-error>
        </mat-form-field>
        <mat-form-field class="form-field-cs"
                        autocomplete="disabled"
        >
            <mat-label>{{ replaceAsteriks('ACTIVATE.MIDDLENAME' | translate) }}</mat-label>
            <input matInput
                   formControlName="middlename"
                   data-cy="middlename-input"
            >
        </mat-form-field>
        <div class="form-button-group">
            <button mat-button
                    (click)="activateAccount()"
                    data-cy="activate-account-submit"
                    [disabled]="activateForm.invalid||formState==='Submitting'"
                    class="form-button-group-button submit"
            >
                {{ 'ACTIVATE.ACTIVATE' | translate }}
            </button>
            <button mat-button
                    (click)="goToLoginPage()"
                    data-cy="goToLoginPage"
                    class="form-button-group-button sign-up"
            >
                {{ 'ACTIVATE.ENTER2' | translate }}
            </button>
        </div>
        <a class="form-button-group-button restore"
           href=""
           target="_blank"
        >
            {{ 'LOGIN.RESTORE' | translate }}
        </a>
    </form>
</div>
